export default "__VITE_PUBLIC_ASSET__5690b43a__"